export const Envs = {
  BFF_WEB_URL: process.env['NX_BFF_WEB_URL'],
  YUNO_PUBLIC_API_KEY: process.env['NX_YUNO_PUBLIC_API_KEY'],
  YUNO_API_URL: process.env['NX_YUNO_API_URL'],
  IUGU_ACCOUNT_ID: process.env['NX_IUGU_ACCOUNT_ID'],
  IUGU_TEST_MODE: process.env['NX_IUGU_TEST_MODE'],
}
